<template>
  <v-row>
    <v-col
      v-if="course.courseStudents && course.courseStudents.length > 0"
      cols="12"
    >
      <v-list>
        <v-subheader>Students</v-subheader>
        <v-list-item v-for="s in course.courseStudents" :key="s.id">
          <v-list-item-action>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="mx-auto" max-width="400" width="200" tile>
                <v-list dense>
                  <v-list-item-group color="primary">
                    <v-list-item @click="removeStudent(s.id)">
                      <v-list-item-icon class="mr-2">
                        <v-icon>mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Remove Student</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-list-item-action>
          <v-list-item-content
            >{{ s.student.firstName }} {{ s.student.lastName }}
            <div v-if="s.student.email">{{ s.student.email }}</div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
    <v-col
      v-if="courseTeachers && courseTeachers.length > 0"
      cols="12"
    >
      <v-list>
        <v-subheader>Teachers</v-subheader>
        <v-list-item v-for="t in courseTeachers" :key="t.id">
          <v-list-item-action>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="mx-auto" max-width="400" width="200" tile>
                <v-list dense>
                  <v-list-item-group color="primary">
                    <v-list-item
                      :to="{
                        name: 'Teacher',
                        params: { id: t.teacherId },
                      }"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon>mdi-account-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>View Teacher</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="removeTeacher(t.id)">
                      <v-list-item-icon class="mr-2">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Remove Teacher</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-list-item-action>
          <v-list-item-content>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{{ t.teacher.firstName }} {{ t.teacher.lastName }}</td>
                </tr>
                <tr v-if="t.teacher.email">
                  <td>Email</td>
                  <td>{{ t.teacher.email }}</td>
                </tr>
                <tr v-if="t.teacher.phone">
                  <td>Phone</td>
                  <td>
                    <the-mask
                      mask="+1(###) ###-####"
                      v-model="t.teacher.phone"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div>
              <teacher-course-schedules
                :courseId="course.id"
                :teacherId="t.teacherId"
                :activeOnly="true"
              />
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
const TeacherCourseSchedules = () =>
  import("@/components/teacher/TeacherCourseSchedules.vue");
import { TheMask } from "vue-the-mask";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  components: {
    TeacherCourseSchedules,
    TheMask,
  },
  computed:{
    ...mapGetters(["isAppLoading", "currentUser"]),
    canViewRate(){
      return this.currentUser.roles.includes("VIEWRATE")
    },
    courseTeachers(){
      if(this.course.courseTeachers){
        return this.course.courseTeachers.filter(ct => ct.teacher && ct.teacher.id)
      }
      else{
        return []
      }
    }
  },
  methods: {
    ...mapActions(["addErrorMessage", "addMessage", "addSuccessMessage"]),
    removeTeacher(courseTeacherId) {
      const params = { courseTeacherId: courseTeacherId };
      this.$axios
        .post("/course/teacher/remove", null, { params })
        .then(() => {
          this.course.courseTeachers.splice(
            this.course.courseTeachers.findIndex(
              (ct) => ct.id == courseTeacherId
            ),
            1
          );
        })
        .catch((err) => {
          const message = err.data;
          this.addErrorMessage(message);
        });
    },
    removeStudent(courseStudentId) {
      if (
        confirm("Please confirm you want to remove student from this course.")
      ) {
        const params = { courseStudentId: courseStudentId };
        this.$axios
          .post("/course/student/remove", null, { params })
          .then(() => {
            this.course.courseStudents.splice(
              this.course.courseStudents.findIndex(
                (cs) => cs.id == courseStudentId
              ),
              1
            );
          })
          .catch((err) => {
            const message = err.data;
            this.addErrorMessage(message);
          });
      }
    },
  },
};
</script>

<style>
</style>